module.exports = __webpack_public_path__ + "img/prize1.d8304ee5.jpg";